export enum RecoilKeys {
  BizsolDisconnectModalState = "bizsolDisconnectModalState",
}
